import { API } from "../../api";
async function return_policy(request) {
    // console.log("return_policy -> request", request);
    return await new API().apiGet({
        baseUrl: process.env.LETS_TRADE_CLIENT_URL ?? "",
        endpoint: `/v2/client/return-policy`,
        authorization: process.env.LETS_TRADE_CLIENT_TOKEN,
    });
}
export { return_policy };
